import { Preferences } from "@capacitor/preferences";

window.handleOAuthCode = async (code) => {
    await Preferences.set({
        key: 'code',
        value: code
    });
    window.location.href = '/callback'; 
};